export const eventStreamPayloadHandler = {
    handle: (next, args) => next(args),
};
